export default __webpack_public_path__ + "static/media/research-slide2.8523cf5a.png";